import { checkServiceAuth } from "../APICalling/ServiceAPICalling";
import {
  checkZohoAuth,
  getAllActiveUsersAndCurrentUser,
  getOrgVariable,
  getOrgVariableList,
  setOrgId,
  setUpDataCenter,
  setUpDataCenterUrl,
  setUpOrgVariable,
} from "../APICalling/ZohoAPICalling";
import {
  API_KEY_API_NAME,
  CREDENTIAL_OF_LOGIN_USER_SERVICE_API_NAME,
  CREDENTIAL_OF_LOGIN_USER_ZOHO_API_NAME,
  DATA_CENTER_API_NAME,
  DATA_CENTER_URL_API_NAME,
  ORG_ID_API_NAME,
  SERVICE_API_KEY_API_NAME,
  SERVICE_AUTHENTICATION_TYPE,
  SERVICE_CONN,
  ZOHO_CONN,
  ZUID_API_NAME,
  Z_API_KEY_API_NAME,
} from "../config/serviceConstant";
const ZOHO = window.ZOHO;

const authCheckZoho = async ({ orgId, apiKey, dataCenterUrl }) => {
  try {
    if (!orgId || !apiKey || !dataCenterUrl) {
      return false;
    }
    const zohoHeaders = {
      orgid: orgId,
      connname: ZOHO_CONN,
      apikey: apiKey,
      datacenterurl: dataCenterUrl,
    };
    return await checkZohoAuth(zohoHeaders);
  } catch (error) {
    return false;
  }
};

const authCheckService = async ({ ZOHO, orgId, apiKey }) => {
  try {
    if (!orgId || !apiKey) {
      return false;
    }
    const serviceHeaders = {
      orgId: orgId,
      connname: SERVICE_CONN,
      apiKey: apiKey,
    };
    let serviceToken = await checkServiceAuth(serviceHeaders);
    if (SERVICE_AUTHENTICATION_TYPE == "apikey") {
      // Set apikey in variable
      await setUpOrgVariable(ZOHO, SERVICE_API_KEY_API_NAME, serviceToken);
      return true;
    }
    return true;
  } catch (error) {
    return false;
  }
};

export async function initZoho(callback) {
  try {
    ZOHO.embeddedApp.on("PageLoad", async function () {
      let extensionData = {};

      // const orgId = await getOrgVariable(ZOHO, ORG_ID_API_NAME);
      // const apiKey = await getOrgVariable(ZOHO, API_KEY_API_NAME);
      // const zApiKey = await getOrgVariable(ZOHO, Z_API_KEY_API_NAME);
      // const zuid = await getOrgVariable(ZOHO, ZUID_API_NAME);

      // const { allUsers, currentUser } = await getAllActiveUsersAndCurrentUser(
      //   ZOHO
      // );

      // const serviceApiKey = await getOrgVariable(
      //   ZOHO,
      //   SERVICE_API_KEY_API_NAME
      // );
      // const dataCenterUrl = await setUpDataCenterUrl(ZOHO);
      // const dataCenter = await setUpDataCenter(ZOHO);

      const orgVariableList = [
        ORG_ID_API_NAME,
        API_KEY_API_NAME,
        DATA_CENTER_API_NAME,
        DATA_CENTER_URL_API_NAME,
        Z_API_KEY_API_NAME,
        ZUID_API_NAME,
      ];
      // orgVariables?.Success?.Content?.easysharepointforcrm__API_KEY?.value
      let orgVariables = await getOrgVariableList(ZOHO, orgVariableList);

      // extensionData["zohoAuth"] = await authCheckZoho({
      //   orgId,
      //   apiKey,
      //   dataCenterUrl,
      // });

      // extensionData["serviceAuth"] = await authCheckService({
      //   ZOHO: ZOHO,
      //   orgId,
      //   apiKey,
      // });

      extensionData["orgId"] = orgVariables[ORG_ID_API_NAME];
      extensionData["apiKey"] = orgVariables[API_KEY_API_NAME];
      extensionData["dataCenterUrl"] = orgVariables[DATA_CENTER_URL_API_NAME];
      extensionData["dataCenter"] = orgVariables[DATA_CENTER_API_NAME];
      extensionData["zuid"] = orgVariables[ZUID_API_NAME];
      extensionData["zApiKey"] = orgVariables[Z_API_KEY_API_NAME];
      // extensionData["serviceApiKey"] = serviceApiKey;
      // extensionData["allUsers"] = allUsers;
      // extensionData["currentUser"] = currentUser;
      extensionData["zohoLoaded"] = true;

      callback(null, extensionData);
    });
    ZOHO.embeddedApp.init().then(() => {});
  } catch (initZohoError) {
    callback(initZohoError, null);
  }
}
